import React from 'react';

export function GlowOrb({ className, style }) {
  return <div className={className} style={style} aria-hidden="true" />;
}

